import {useEffect, useState} from 'react';
import {default as SpinnerBase} from '../ui-kit_override/spinner/BaseSpinner';

interface HTMLElementSpinner extends HTMLElement {
    dfbSpinner?: SpinnerBase;
}

export type SpinnerProps = {
    id: string
    showLoader: boolean
}

const Spinner = ({id, showLoader}: SpinnerProps) => {
    const [ref, setRef] = useState<HTMLElement | null>(null);

    useEffect(() => {
        if (!ref) {
            return;
        }
        const spinnerElementContinuous: HTMLElementSpinner | null = document.getElementById(id);

        if (!spinnerElementContinuous) {
            return;
        }

        if (!spinnerElementContinuous.dfbSpinner) {
            // @ts-ignore
            spinnerElementContinuous.dfbSpinner = new SpinnerBase(spinnerElementContinuous);
        }

        if (showLoader) {
            spinnerElementContinuous.dfbSpinner.loop();
        } else {
            spinnerElementContinuous.dfbSpinner.stop();
        }
    }, [ref, showLoader, id]);

    return (
        <div ref={setRef} className="dfb-Spinner dfb-Spinner--continuous" role="progressbar" id={id}>
            <div className="dfb-Spinner-value">0</div>
        </div>
    );
};

Spinner.defaultProps = {
    id: 'dfb-spinner-continuous'
};

export default Spinner;
